
import { Component, Vue, Watch } from "vue-property-decorator";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import YtoTableWithFullHeight from "@/views/components/YtoTable/YtoTableWithFullHeight.vue";
import Scan from "@/views/components/Scan/Scan.vue";
import ScanWithFullHeight from "@/views/components/Scan/ScanWithFullHeight.vue";
import config from "./config";
import Form1 from "./Form1.vue";
import Form2 from "./Form2.vue";
import TableHeader from "./TableHeader.vue";
import { LogHelper } from "@/common/LogHelper";
import { ApiQueryType, ModeType } from "@/common/glboalconstant";
import dayjs from "dayjs";

import {
  playSuccessSound,
  playFailSound,
  NoticeVoiceInit,
} from "@/common/voiceTip";
import {
  checkCode,
  toolsRegularCheckCode,
  getCqNoByCpNo,
  truckOperation,
} from "@/api/service";
import {CarContainerStatus} from "@/api/serviceHelper"
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
@Component({
  name: "scanforresolvecar",
  components: {
    YtoTable,
    YtoTableWithFullHeight,
    Form1,
    Form2,
    TableHeader,
    Scan,
    ScanWithFullHeight,
  },
})
export default class extends Vue {
  public inputModel: inputDataModel_ResolveCar = {
    input_ScanCode: "",
    input_CarSignNum: "",
    input_SignatureStatue: "",
    input_MidSignatureNum: "",
    input_LastSignatureNum: "",
    input_ReasonForSignatureStatue: "",
  };
  public globalConfig: any = {};
  public systemConfig: any = {};
  public loginData: any = {};

  public nTotalScanNum = 0;
  public totalScanCount = "0";

  public msg = "";
  public config = config;
  public currentrow = null;
  public showList = [];
  public ytoCode = "";

  public deviceItems: deviceItem[] = [];
  public errormessage = "";
  public index = 1;
  public callbackmodel = {};

  mounted() {
    try {
      this.globalConfig = SystemConfigModule.globalData;
      this.systemConfig = SystemConfigModule.systemData;
      this.loginData = SystemConfigModule.loginData;
    } catch (error) {
      console.log("解车扫描界面:注册回调函数异常" + error);
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }

  //测试
  private testerror() {
    playFailSound();

    LogHelper.WriteLog(
      this.deleteClick({ strCarCode: this.ytoCode, index: 1 })
    );
  }
  //从form1获取参数
  private getFormValue(element) {
    LogHelper.WriteLog("收到form1传的数据");
    this.inputModel = element;
  }
  //表格选中动作
  private currentRowChanged(element) {
    this.currentrow = element;
    this.callbackmodel = this.inputModel;
  }
  //删除数据
  public deletedatahistory() {
    if (this.currentrow === null) {
      this.$message.warning("请先选择要删除的行");
      return;
    }
    this.$confirm("是否确定要删除此数据？", "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        try {
          if (this.deleteClick(this.currentrow)) {
            this.currentrow = null;
          }
        } catch (error) {
          console.log("删除失败：" + error.message);
        }
      })
      .catch(() => {
        console.log("取消删除");
      });
  }
  //删除动作
  private deleteClick(currentRow) {
    debugger;
    let strCode = currentRow.strCarCode;
    let nRes = this.DeleteData(currentRow);
    if (nRes == 0) {
      if (this.showList.length > 0) {
        let _showlist = this.showList;
        var _data = _showlist.filter(
          (item) =>
            !(
              item.index == currentRow.index &&
              item.strCarCode == currentRow.strCarCode
            )
        );
        this.showList = _data;
      }
      this.clearData();
      this.errormessage = "删除成功！";
      if (this.nTotalScanNum > 0) this.nTotalScanNum--;
      this.totalScanCount = this.nTotalScanNum.toString();
      LogHelper.WriteLog(
        "ScanForResolveCar_Delete:" + "Barcode " + strCode + " is Deleted"
      );
    }
    return true;
  }
  //具体删除请求
  private DeleteData(row) {
    try {
      let datetimeNow = new Date().valueOf();

      let stResolveCarData: any = {};

      //后续与对应填写，现无法获取数据
      stResolveCarData.devMac = this.globalConfig.LocalMac;
      stResolveCarData.devType = "0";
      let _body: any = {};
      _body.mac = this.globalConfig.LocalMacIPv4;
      _body.aviType = 0;
      _body.trace = 0;
      _body.isFirstTransfer = 1;
      _body.mty = "0100"; //到车
      stResolveCarData.body = _body;

      let _opRecord: any = {};
      _opRecord.auxOpCode = "DELETE";
      _opRecord.auxRouteCode = "";

      _opRecord.createOrgCode = this.loginData.orgCode; //创建组织网点，待优化
      _opRecord.createTerminal = this.globalConfig.LocalIPv4;
      // _opRecord.createTime = (DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000;
      _opRecord.createTime = datetimeNow;
      _opRecord.createUserCode = this.loginData.userCode;
      _opRecord.createUserName = this.loginData.employeeName;
      _opRecord.deviceType = this.globalConfig.CurrentDeviceType.toString();
      _opRecord.expType = 40;
      _opRecord.feeAmt = "";
      _opRecord.feeFlag = 0;
      _opRecord.frequencyNo = "";
      _opRecord.lineNo = "";
      _opRecord.modifyOrgCode = "";
      _opRecord.modifyTerminal = "";
      // _opRecord.modifyTime = (DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000;
      _opRecord.modifyTime = datetimeNow;

      _opRecord.modifyUserCode = "";
      _opRecord.modifyUserName = "";
      _opRecord.nextOrgCode = "";
      _opRecord.opCode = 169; //160到车，169解车，139封车，140发车
      _opRecord.orgCode = this.loginData.orgCode;
      _opRecord.pkgQty = 1;
      _opRecord.refId = "";
      _opRecord.remark = "10010001";
      _opRecord.routeCode = "";
      _opRecord.status = "";
      _opRecord.transferStatus = 0;
      // _opRecord.uploadTime = (DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000;
      _opRecord.uploadTime = datetimeNow;
      _opRecord.vehiclePlateNo = "";
      // _opRecord.waybillNo = row.strCarCode;
      _opRecord.waybillNo = row.strCarCode;
      stResolveCarData.body.opRecord = _opRecord;

      let _customData: any = {};

      _customData.backGateSealNo = row.strBackSigntureCode;
      _customData.createTimeStr = "";
      _customData.driverNo = "";
      _customData.expCheckResults = "";
      _customData.expOrgDbInfoDto = "";
      _customData.isSupportFrontDb = "";
      _customData.midGateSealNo = row.strMidSigntureCode;
      _customData.modifyTimeStr = "";
      _customData.newModule = "false";
      _customData.opOrgType = "";
      // _customData.otFlag = "";
      _customData.sealBreakReason = row.strReasonForSigntureStatus;
      _customData.sealStatus = row.strSigntureStatus;
      _customData.snNo = "test";
      _customData.traceStatus = "";
      _customData.uploadTimeStr = "";
      _customData.volume = "";
      _customData.extend1 = "";
      _customData.extend2 = "";
      stResolveCarData.body.opRecord.customData = _customData;

      let strReturnStr = truckOperation(JSON.stringify(stResolveCarData));
      let strReturn = JSON.parse(strReturnStr);
      if (strReturn.respcode != "000") {
        this.errormessage = strReturn.respMessage;
        if (strReturn.respcode == "101") {
          return 2;
        } else {
          LogHelper.WriteLog("ScanForResolveCar " + strReturn);
          return 1;
        }
      } else {
        // ToolsOpearation.RefreshLoaclTime(stReturn.data.serverTime);
        try {
          obj_System_Core.refreshLoaclTime(
            strReturn.data.serverTime.toString()
          );
        } catch (error) {
          LogHelper.WriteLog(error);
        }
        LogHelper.WriteLog(strReturn.data.serverTime);
      }
      return 0;
    } catch (ex) {
      LogHelper.WriteLog(
        "ScanForResolveCar " + "UploadDataToServer crash! " + ex
      );
      return 1;
    }
  }

  //扫描区扫码
  private ytocodeget() {
    this.inputModel.input_ScanCode = this.ytoCode.toUpperCase();
    try {
      var scanAreaContent = this.inputModel.input_ScanCode.toUpperCase().trim();
      if (scanAreaContent == "") {
        try {
          playFailSound();
          this.errormessage = "输入为空";
          return;
        } catch (Exception) {
          this.errormessage = "输入为空,警告提示音不存在";
          return;
        }
      }
      var reg1 = new RegExp(/^[A-Za-z0-9]+$/);
      if (!reg1.test(scanAreaContent)) {
        this.errormessage = "输入数据非法，只能输入数字和字母";
        return;
      }
      this.errormessage = "";

      let bReturnState = true;

      let stCodeCheckInput: any = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          queryValue: scanAreaContent,
          queryType: "0",
          viewType: "1",
          extend1: "",
          extend2: "",
          extend3: "",
        },
      };
      //先本地
      let stReturnData = this.CheckCode(stCodeCheckInput);
      this.errormessage = stReturnData.respMessage;
      LogHelper.WriteLog(stReturnData);
      if (stReturnData.respcode != "000") {
        try {
          // // ToolsPlayVoice.CreateSingleInstance().PlayAsycSound(strOperFailVoice);
          playFailSound();
        } catch (Exception) {
          this.errormessage = "失败提示音不存在";
        }

        bReturnState = false;
        if (
          stReturnData.respMessage == "" ||
          stReturnData.respMessage == null ||
          stReturnData.respMessage == undefined
        ) {
          this.errormessage = "服务器掉线";
        } else {
          this.errormessage = stReturnData.respMessage;
        }
      } else {
        debugger;
        if (
          stReturnData.data.queryNoType == ApiQueryType.strCarCode ||
          stReturnData.data.queryNoType == ApiQueryType.strCarInfoCode
        ) {
          if (stReturnData.data.queryNoType == ApiQueryType.strCarInfoCode) {
            LogHelper.WriteLog("解车操作查询cp码");

            var carCode = this.DoWithCarInfoCode(scanAreaContent);
            if (carCode == null || carCode == "" || carCode == undefined) {
              this.errormessage =
                "未查询到车签号，请重扫或直接扫描车签号条码！";
              return;
            } else {
              //车签号
              this.inputModel.input_CarSignNum = carCode;
            }
          } else {
            if (stReturnData.data.queryNo.toString().indexOf("CQ") != -1 && stReturnData.data.queryNo.toString().length == 20) {
              this.errormessage = "系统生成的车签，不允许人工录入";
              return;
            }
            //车签号
            this.inputModel.input_CarSignNum = stReturnData.data.queryNo;
          }

          if (this.inputModel.input_CarSignNum.startsWith("CQ")) {
            debugger;
            var response = CarContainerStatus(
              this.inputModel.input_CarSignNum,
              this.globalConfig.LocalMac,
              this.globalConfig.CurrentDeviceType.toString()
            );
            console.log(response);
            if (response.status != "1") {
              this.errormessage = response.resMsg;
              this.inputModel.input_CarSignNum = "";
              return;
            }
          }
          //解车操作
          if (!this.SendDataToServer()) {
            return;
          }

          try {
            playSuccessSound();
          } catch {
            this.errormessage = "成功提示音不存在";
          }
        } else if (
          stReturnData.data.queryNoType == ApiQueryType.strSinatureCode
        ) {
          if (
            this.inputModel.input_LastSignatureNum == "" &&
            this.inputModel.input_MidSignatureNum == ""
          ) {
            this.inputModel.input_LastSignatureNum = scanAreaContent;
            return;
          } else if (
            this.inputModel.input_LastSignatureNum != "" &&
            this.inputModel.input_MidSignatureNum == ""
          ) {
            this.inputModel.input_MidSignatureNum = scanAreaContent;
            return;
          } else if (
            this.inputModel.input_LastSignatureNum != "" &&
            this.inputModel.input_MidSignatureNum != ""
          ) {
            this.inputModel.input_LastSignatureNum = scanAreaContent;
            return;
          }
        } else {
          this.errormessage = "输入非法的签封或车签";
          try {
            playFailSound();
            //tbx_scanArea.SelectAll();
            bReturnState = false;
          } catch (Exception) {
            this.errormessage = "失败提示音不存在";
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }
  //触发到车上传
  private SendDataToServer() {
    var IntReturn = -1;
    IntReturn = this.UploadDataToServer(
      this.inputModel.input_CarSignNum,
      169,
      "NEW"
    );
    if (IntReturn == 1 || IntReturn == 2) {
      //重复就选中
      if (IntReturn == 2) {
        //for (int i = 0; i < dataGridView1.Rows.Count; i++)
        //{
        //    var v = dataGridView1.Rows[i].DataBoundItem as CODE_DATA＿ArriveCar;
        //    if (v.strCarCode == tbx_carSignNum.Text)
        //    {
        //        dataGridView1.Rows[i].Selected = true;
        //        break;
        //    }
        //}
      } else {
        try {
          playFailSound();
        } catch (Exception) {
          this.errormessage = "失败提示音不存在";
        }
      }
      return false;
    }
    this.InsertDataToList();
    this.clearData();

    this.nTotalScanNum++;
    this.totalScanCount = this.nTotalScanNum.toString();

    return true;
  }
  //清除参数
  private clearData() {
    this.inputModel.input_CarSignNum = "";
    this.inputModel.input_LastSignatureNum = "";
    this.inputModel.input_MidSignatureNum = "";
    this.inputModel.input_ReasonForSignatureStatue = "";
  }
  //解车上传动作
  private UploadDataToServer(strwaybillNo, opCode, strauxOpCode) {
    try {
      debugger;
      let datetimeNow = new Date().valueOf();
      //后续与对应填写，现无法获取数据

      let stResolveCarData: any = {};
      stResolveCarData.devMac = this.globalConfig.LocalMac;
      stResolveCarData.devType = "0";

      let _body: any = {};
      _body.mac = this.globalConfig.LocalMacIPv4;
      _body.aviType = 0;
      _body.trace = 0;
      _body.isFirstTransfer = 1;
      _body.mty = "0100"; //解车
      stResolveCarData.body = _body;

      let _opRecord: any = {};
      _opRecord.auxOpCode = strauxOpCode;
      _opRecord.auxRouteCode = "";

      _opRecord.createOrgCode = this.loginData.orgCode; //创建组织网点，待优化
      _opRecord.createTerminal = this.globalConfig.LocalIPv4;
      //  createTime : (DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000,//DateTime.Now.ToString("yyyy-MM-dd HH:mm:ss");
      _opRecord.createTime = datetimeNow;
      _opRecord.createUserCode = this.loginData.userCode;
      _opRecord.createUserName = this.loginData.employeeName;
      _opRecord.deviceType = this.globalConfig.CurrentDeviceType.toString();
      _opRecord.expType = 40;
      _opRecord.feeAmt = "";
      _opRecord.feeFlag = 0;
      _opRecord.frequencyNo = "";
      _opRecord.lineNo = "";
      _opRecord.modifyOrgCode = "";
      _opRecord.modifyTerminal = "";
      //  modifyTime :(DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000,
      _opRecord.modifyTime = datetimeNow;

      _opRecord.modifyUserCode = "";
      _opRecord.modifyUserName = "";
      _opRecord.nextOrgCode = "";
      _opRecord.opCode = opCode;
      _opRecord.orgCode = this.loginData.orgCode;
      _opRecord.pkgQty = 1;
      _opRecord.refId = "";
      _opRecord.remark = "10010001";
      _opRecord.routeCode = "";
      _opRecord.status = "";
      _opRecord.transferStatus = 0;
      //  uploadTime : (DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000,
      _opRecord.uploadTime = datetimeNow;
      _opRecord.vehiclePlateNo = "";
      _opRecord.waybillNo = this.inputModel.input_CarSignNum;
      stResolveCarData.body.opRecord = _opRecord;

      let _customData: any = {};
      _customData.backGateSealNo = this.inputModel.input_LastSignatureNum;
      _customData.createTimeStr = "";
      _customData.driverNo = "";
      _customData.expCheckResults = "";
      _customData.expOrgDbInfoDto = "";
      _customData.isSupportFrontDb = "";
      _customData.midGateSealNo = this.inputModel.input_MidSignatureNum;
      _customData.modifyTimeStr = "";
      _customData.newModule = "false";
      _customData.opOrgType = "";
      // stResolveCarData.body.opRecord.customData.otFlag = "";
      _customData.sealBreakReason =
        this.inputModel.input_ReasonForSignatureStatue;
      _customData.sealStatus = this.inputModel.input_SignatureStatue;
      _customData.snNo = "test";
      _customData.traceStatus = "";
      _customData.uploadTimeStr = "";
      _customData.volume = "";
      _customData.extend1 = "";
      _customData.extend2 = "";
      stResolveCarData.body.opRecord.customData = _customData;

      var strReturnStr = truckOperation(JSON.stringify(stResolveCarData));
      var strReturn = JSON.parse(strReturnStr);
      debugger;
      if (strReturn.respcode != "000") {
        if (
          this.systemConfig.ModeInfo.Mode_Type == ModeType.CrazeScanOutputType
        ) {
          //狂扫失败日志单独记录
          // LogForCrazy.WriteLogAsyn(strwaybillNo + "," + stReturn.respMessage);
          LogHelper.LogForCrazy(strwaybillNo + "," + strReturn.respMessage);
        }
        this.errormessage = strReturn.respMessage;
        if (strReturn.respcode == "101") {
          return 2;
        } else {
          LogHelper.WriteLog("ScanForResolveCarNew " + strReturn);
          return 1;
        }
      } else {
        ///根据业务网关返回的时间，更新系统时间
        //ToolsOpearation.RefreshLoaclTime(stReturn.data.serverTime);
        try {
          obj_System_Core.refreshLoaclTime(
            strReturn.data.serverTime.toString()
          );
        } catch (error) {
          LogHelper.Error(error);
        }
        LogHelper.WriteLog(strReturn.data.serverTime);
      }
      return 0;
    } catch (ex) {
      LogHelper.Error("ScanForResolveCar " + "UploadDataToServer crash! " + ex);
      return 1;
    }
  }
  //插入表格
  private InsertDataToList() {
    let datetime = dayjs();
    var data: any = {
      strCarCode: this.inputModel.input_CarSignNum,
      strBackSigntureCode: this.inputModel.input_LastSignatureNum,
      strMidSigntureCode: this.inputModel.input_MidSignatureNum,
      strSigntureStatus: this.inputModel.input_SignatureStatue,
      strReasonForSigntureStatus:
        this.inputModel.input_ReasonForSignatureStatue,
      strResolveTime: datetime.format("YYYY-MM-DD HH:mm:ss"),
      state: "上传成功",
      strTip: "",
      index: this.index,
    };
    this.index++;
    //  let datetime = package_DataByQueue.ScanTime;
    //   let datetimeStr = datetime.format("YYYY-MM-DD HH:mm:ss");
    // package_DataByQueue.ScanTime = datetimeStr;
    this.showList.unshift(data);
    while (this.showList.length > 50) {
      this.showList.pop();
    }
  }
  //根据CP码查询车签
  private DoWithCarInfoCode(carCodeInfo) {
    let carCode = "";
    try {
      let jbody = {
        queryValue: carCodeInfo,
        queryType: "30",
        viewType: "",
        extend1: "2", //1表示上车/封车/发车、2表示下车/到车/解车
        extend2: "",
        extend3: "",
      };

      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: this.globalConfig.CurrentDeviceType.toString(),
        body: jbody,
      };
      let responseStr = getCqNoByCpNo(JSON.stringify(request));
      let response = JSON.parse(responseStr);
      let jresponse = response.data;
      if (jresponse.extend1 != null) {
        carCode = jresponse.extend1;
      }
    } catch (ex) {
      // LogHelper.WriteLog("上车 DoWithCarInfoCode" + ex);
      LogHelper.WriteLog("到车根据CP码查询车签" + ex);
    }
    return carCode;
  }
  //条码规则判断
  private CheckCode(stCodeCheckInput) {
    let _resultStr = toolsRegularCheckCode(JSON.stringify(stCodeCheckInput));
    if (_resultStr != null && _resultStr.length > 0) {
      var _result = JSON.parse(_resultStr);
      return _result;
    } else {
      let responseStr = checkCode(JSON.stringify(stCodeCheckInput));
      if (responseStr != null && responseStr.length > 0) {
        var response = JSON.parse(responseStr);
        return response;
      }
    }

    return null;
  }
  //获取焦点
  public selectElementContents(el) {
    el.blur();
    el.focus();
  }
}
